"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_exports = {};
__export(index_exports, {
  LiveQuery: () => LiveQuery
});
module.exports = __toCommonJS(index_exports);
var import_analytics = require("@hcengineering/analytics");
var import_core = __toESM(require("@hcengineering/core"));
var import_platform = require("@hcengineering/platform");
var import_fast_equals = require("fast-equals");
var import_refs = require("./refs");
var import_results = require("./results");
const CACHE_SIZE = 125;
class LiveQuery {
  static {
    __name(this, "LiveQuery");
  }
  client;
  queries = /* @__PURE__ */ new Map();
  queue = /* @__PURE__ */ new Map();
  queryCounter = 0;
  closed = false;
  queriesToUpdate = /* @__PURE__ */ new Map();
  refs = new import_refs.Refs(() => this.getHierarchy());
  constructor(client) {
    this.client = client;
  }
  isClosed() {
    return this.closed;
  }
  async close() {
    this.closed = true;
    await this.client.close();
  }
  getHierarchy() {
    return this.client.getHierarchy();
  }
  getModel() {
    return this.client.getModel();
  }
  // Perform refresh of content since connection established.
  async refreshConnect(clean) {
    for (const q of [...this.queue.values()]) {
      if (!this.removeFromQueue(q)) {
        try {
          if (clean) {
            this.cleanQuery(q);
          }
        } catch (err) {
          if (err instanceof import_platform.PlatformError) {
            if (err.message === "connection closed") {
              continue;
            }
          }
          import_analytics.Analytics.handleError(err);
          console.error(err);
        }
      } else {
        this.removeQueue(q);
      }
    }
    for (const v of this.queries.values()) {
      for (const q of v.values()) {
        try {
          if (clean) {
            this.cleanQuery(q);
          }
          void this.refresh(q);
        } catch (err) {
          if (err instanceof import_platform.PlatformError) {
            if (err.message === "connection closed") {
              continue;
            }
          }
          import_analytics.Analytics.handleError(err);
          console.error(err);
        }
      }
    }
  }
  cleanQuery(q) {
    q.callbacks.forEach((callback) => {
      callback((0, import_core.toFindResult)([], 0));
    });
    q.result = new import_results.ResultArray([], this.getHierarchy());
    q.total = -1;
  }
  match(q, doc, skipLookup = false) {
    if (this.getHierarchy().isMixin(q._class)) {
      if (this.getHierarchy().hasMixin(doc, q._class)) {
        doc = this.getHierarchy().as(doc, q._class);
      } else {
        return false;
      }
    }
    if (!this.getHierarchy().isDerived(doc._class, q._class)) {
      const mixinClass = import_core.Hierarchy.mixinClass(doc);
      if (mixinClass === void 0 || !this.getHierarchy().isDerived(mixinClass, q._class)) {
        return false;
      }
    }
    const query = q.query;
    for (const key in query) {
      if (key === "$search") continue;
      if (skipLookup && key.startsWith("$lookup")) continue;
      const value = query[key];
      const result = (0, import_core.findProperty)([doc], key, value);
      if (result.length === 0) {
        return false;
      }
    }
    return true;
  }
  createDumpQuery(_class, query, options) {
    const q = this.createQuery(_class, query, void 0, options);
    this.queue.set(q.id, { ...q, lastUsed: (0, import_core.platformNow)() });
    if (!(q.result instanceof Promise)) {
      q.result.clean();
    }
    return q;
  }
  async findAll(_class, query, options) {
    if (this.client.getHierarchy().getDomain(_class) === import_core.DOMAIN_MODEL) {
      return await this.client.findAll(_class, query, options);
    }
    const opt = { ...options ?? {} };
    if (opt.projection !== void 0) {
      opt.projection = {
        ...opt.projection,
        _class: 1,
        space: 1,
        modifiedOn: 1
      };
    }
    const d = this.refs.findFromDocs(_class, query, opt);
    if (d !== null) {
      return d;
    }
    const q = this.findQuery(_class, query, opt) ?? this.createDumpQuery(_class, query, opt);
    if (q.result instanceof Promise) {
      q.result = await q.result;
    }
    if (this.removeFromQueue(q, false)) {
      this.queue.set(q.id, { ...q, lastUsed: (0, import_core.platformNow)() });
      q.result.clean();
    }
    return (0, import_core.toFindResult)(q.result.getClone(), q.total);
  }
  async domainRequest(domain, params, options) {
    return await this.client.domainRequest(domain, params, options);
  }
  searchFulltext(query, options) {
    return this.client.searchFulltext(query, options);
  }
  async findOne(_class, query, options) {
    if (this.client.getHierarchy().getDomain(_class) === import_core.DOMAIN_MODEL) {
      return await this.client.findOne(_class, query, options);
    }
    if (options?.projection !== void 0) {
      options.projection = {
        ...options.projection,
        _class: 1,
        space: 1,
        modifiedOn: 1
      };
    }
    if (options === void 0) {
      options = {};
    }
    options.limit = 1;
    const d = this.refs.findFromDocs(_class, query, options);
    if (d !== null) {
      return d[0];
    }
    const q = this.findQuery(_class, query, options) ?? this.createDumpQuery(_class, query, options);
    if (q.result instanceof Promise) {
      q.result = await q.result;
    }
    if (this.removeFromQueue(q, false)) {
      this.queue.set(q.id, { ...q, lastUsed: (0, import_core.platformNow)() });
      q.result.clean();
    }
    return q.result.getClone().shift();
  }
  optionsCompare(opt1, opt2) {
    const { ctx: _1, ..._opt1 } = opt1 ?? {};
    const { ctx: _2, ..._opt2 } = opt2 ?? {};
    return (0, import_fast_equals.deepEqual)(_opt1, _opt2);
  }
  queryCompare(q1, q2) {
    if (Object.keys(q1).length !== Object.keys(q2).length) {
      return false;
    }
    return (0, import_fast_equals.deepEqual)(q1, q2);
  }
  findQuery(_class, query, options) {
    const queries = this.getQueueMap(_class);
    if (queries === void 0) return;
    for (const q of queries.values()) {
      if (!this.queryCompare(query, q.query) || !this.optionsCompare(options, q.options)) continue;
      return q;
    }
  }
  removeFromQueue(q, update = true) {
    if (q.callbacks.size === 0) {
      const removed = this.queue.delete(q.id);
      if (removed) {
        if (update) {
          if (!(q.result instanceof Promise)) {
            this.refs.updateDocuments(q, q.result.getDocs(), true);
          }
        }
        return true;
      }
    }
    return false;
  }
  pushCallback(q, callback) {
    q.callbacks.set(callback.callbackId, callback.callback);
    setTimeout(async () => {
      if (q !== void 0) {
        if (q.result instanceof Promise) {
          q.result = await q.result;
        }
        callback.callback((0, import_core.toFindResult)(q.result.getResult(callback.callbackId), q.total));
      }
    }, 0);
  }
  getQuery(_class, query, callback, options) {
    const current = this.findQuery(_class, query, options);
    if (current !== void 0) {
      this.removeFromQueue(current, false);
      this.pushCallback(current, callback);
      return current;
    }
  }
  getQueueMap(_class) {
    let cq = this.queries.get(_class);
    if (cq === void 0) {
      cq = /* @__PURE__ */ new Map();
      this.queries.set(_class, cq);
    }
    return cq;
  }
  createQuery(_class, query, callback, options) {
    const _query = (0, import_core.clone)(query);
    const localResult = this.refs.findFromDocs(_class, query, options);
    const result = localResult != null ? Promise.resolve(localResult) : this.client.findAll(_class, query, options);
    const q = {
      id: ++this.queryCounter,
      _class,
      query: _query,
      result: result.then((docs) => new import_results.ResultArray(docs, this.getHierarchy())),
      total: 0,
      options,
      callbacks: /* @__PURE__ */ new Map(),
      refresh: (0, import_core.reduceCalls)(() => this.doRefresh(q)),
      refreshId: 0
    };
    if (callback !== void 0) {
      q.callbacks.set(callback.callbackId, callback.callback);
    }
    this.getQueueMap(_class).set(q.id, q);
    result.then(async (result2) => {
      q.total = result2.total;
      await this.callback(q);
    }).catch((err) => {
      import_analytics.Analytics.handleError(err);
      console.log("failed to update Live Query: ", err);
    });
    if (this.queue.size > CACHE_SIZE) {
      this.remove();
    }
    return q;
  }
  remove() {
    const used = Array.from(this.queue.values()).sort((a, b) => a.lastUsed - b.lastUsed);
    const targetSize = Math.floor(CACHE_SIZE * 0.8);
    const toRemove = Math.max(0, this.queue.size - targetSize);
    for (let i = 0; i < toRemove; i++) {
      const q = used.shift();
      if (q === void 0) return;
      this.removeQueue(q);
    }
  }
  removeQueue(q) {
    const queries = this.getQueueMap(q._class);
    const removed = queries.delete(q.id);
    this.queue.delete(q.id);
    if (removed) {
      if (!(q.result instanceof Promise)) {
        this.refs.updateDocuments(q, q.result.getDocs(), true);
      }
    }
  }
  query(_class, query, callback, options) {
    if (options?.projection !== void 0) {
      options.projection = {
        ...options.projection,
        _class: 1,
        space: 1,
        modifiedOn: 1
      };
    }
    const callbackId = (0, import_core.generateId)();
    const q = this.getQuery(_class, query, { callback, callbackId }, options) ?? this.createQuery(_class, query, { callback, callbackId }, options);
    return () => {
      q.callbacks.delete(callbackId);
      if (q.callbacks.size === 0) {
        if (!(q.result instanceof Promise)) {
          q.result.clean();
        }
        this.queue.set(q.id, { ...q, lastUsed: (0, import_core.platformNow)() });
        if (this.queue.size > CACHE_SIZE) {
          this.remove();
        }
      }
    };
  }
  async queryFind(_class, query, options) {
    if (options?.projection !== void 0) {
      options.projection = {
        ...options.projection,
        _class: 1,
        space: 1,
        modifiedOn: 1
      };
    }
    const current = this.findQuery(_class, query, options);
    if (current === void 0) {
      const q = this.createQuery(
        _class,
        query,
        void 0,
        // No need of callback
        options
      );
      if (q.result instanceof Promise) {
        q.result = await q.result;
      }
      return (0, import_core.toFindResult)(q.result.getClone(), q.total);
    }
    if (current.result instanceof Promise) {
      current.result = await current.result;
    }
    return (0, import_core.toFindResult)(current.result.getClone(), current.total);
  }
  async checkSearch(q, _id) {
    const match = await this.client.findOne(q._class, { $search: q.query.$search, _id }, q.options);
    if (q.result instanceof Promise) {
      q.result = await q.result;
    }
    if (match === void 0) {
      if (q.options?.limit === q.result.length) {
        await this.refresh(q);
        return true;
      } else {
        const doc = q.result.delete(_id);
        if (doc !== void 0) {
          this.refs.updateDocuments(q, [doc], true);
          if (q.options?.total === true) {
            q.total--;
          }
        }
      }
    } else {
      const doc = q.result.findDoc(_id);
      if (doc !== void 0) {
        q.result.updateDoc(match, false);
        this.refs.updateDocuments(q, [match]);
      }
    }
    return false;
  }
  async getDocFromCache(docCache, _id, _class, space, q) {
    const options = {};
    if (q.options?.associations !== void 0) {
      options.associations = q.options?.associations;
    }
    if (q.options?.lookup !== void 0) {
      options.lookup = q.options?.lookup;
    }
    const showArchived = (0, import_core.shouldShowArchived)(q.query, q.options);
    options.showArchived = showArchived;
    const docIdKey = _id + JSON.stringify(options ?? {}) + q._class;
    const current = docCache.get(docIdKey) ?? await this.client.findOne(q._class, { _id, space }, options);
    if (current !== void 0) {
      docCache.set(docIdKey, current);
    } else {
      docCache.delete(docIdKey);
    }
    return current;
  }
  asMixin(doc, mixin) {
    if (this.getHierarchy().isMixin(mixin)) {
      return this.getHierarchy().as(doc, mixin);
    }
    return doc;
  }
  async getCurrentDoc(q, _id, space, docCache) {
    let current = await this.getDocFromCache(docCache, _id, q._class, space, q);
    if (q.result instanceof Promise) {
      q.result = await q.result;
    }
    const pos = q.result.findDoc(_id);
    if (current !== void 0) {
      current = this.asMixin(current, q._class);
    }
    if (current !== void 0 && this.match(q, current)) {
      q.result.updateDoc(current, false);
      this.refs.updateDocuments(q, [current]);
    } else {
      if (q.options?.limit === q.result.length) {
        await this.refresh(q);
        return true;
      } else if (pos !== void 0) {
        q.result.delete(_id);
        this.refs.updateDocuments(q, [pos], true);
        if (q.options?.total === true) {
          q.total--;
        }
      }
    }
    return false;
  }
  async __updateMixinDoc(q, updatedDoc, tx) {
    updatedDoc = import_core.TxProcessor.updateMixin4Doc(updatedDoc, tx);
    const ops = {
      ...tx.attributes,
      modifiedBy: tx.modifiedBy,
      modifiedOn: tx.modifiedOn
    };
    await this.__updateLookup(q, updatedDoc, ops);
  }
  checkUpdatedDocMatch(q, result, updatedDoc) {
    if (!this.match(q, updatedDoc)) {
      if (q.options?.limit === result.length) {
        void this.refresh(q);
        return true;
      } else {
        result.delete(updatedDoc._id);
        this.refs.updateDocuments(q, [updatedDoc], true);
        if (q.options?.total === true) {
          q.total--;
        }
      }
    } else {
      result.updateDoc(updatedDoc, false);
      this.refs.updateDocuments(q, [updatedDoc]);
    }
    return false;
  }
  async txMixin(tx, docCache) {
    const hierarchy = this.client.getHierarchy();
    for (const queries of this.queries.entries()) {
      const isTx = hierarchy.isDerived(queries[0], import_core.default.class.Tx);
      for (const q of queries[1].values()) {
        if (isTx) {
          if (this.match(q, tx, q.options?.lookup !== void 0)) {
            await this.handleDocAdd(q, tx, true, docCache);
          }
          await this.handleDocAddLookup(q, tx);
          continue;
        }
        if (q.result instanceof Promise) {
          q.result = await q.result;
        }
        let updatedDoc = q.result.findDoc(tx.objectId);
        if (updatedDoc !== void 0) {
          if (q.query.$search != null && q.query.$search.length > 0) {
            const searchRefresh = await this.checkSearch(q, tx.objectId);
            if (searchRefresh) {
              continue;
            }
          } else {
            if (updatedDoc.modifiedOn < tx.modifiedOn) {
              await this.__updateMixinDoc(q, updatedDoc, tx);
              updatedDoc = this.asMixin(updatedDoc, q._class);
              const updateRefresh = this.checkUpdatedDocMatch(q, q.result, updatedDoc);
              if (updateRefresh) {
                continue;
              }
            } else {
              const currentRefresh = await this.getCurrentDoc(q, updatedDoc._id, updatedDoc.space, docCache);
              if (currentRefresh) {
                continue;
              }
            }
          }
          await this.sort(q, tx);
          const udoc = q.result.findDoc(tx.objectId);
          await this.updatedDocCallback(q, q.result, udoc);
        } else if (queries[0] === tx.mixin) {
          const doc = await this.client.findOne(q._class, { ...q.query, _id: tx.objectId }, q.options);
          if (doc !== void 0) {
            if (this.match(q, doc, q.options?.lookup !== void 0)) {
              await this.handleDocAdd(q, doc, false, docCache);
            }
            await this.handleDocAddLookup(q, doc);
          }
        }
        await this.handleDocUpdateLookup(q, tx);
        await this.handleDocUpdateRelation(q, tx);
      }
    }
    return {};
  }
  async txUpdateDoc(tx, docCache) {
    for (const queries of this.queries.entries()) {
      const isTx = this.client.getHierarchy().isDerived(queries[0], import_core.default.class.Tx);
      for (const q of queries[1].values()) {
        if (isTx) {
          if (this.match(q, tx, q.options?.lookup !== void 0)) {
            await this.handleDocAdd(q, tx, true, docCache);
          }
          await this.handleDocAddLookup(q, tx);
          continue;
        }
        await this.handleDocUpdate(q, tx, docCache);
      }
    }
    return {};
  }
  async handleDocUpdate(q, tx, docCache) {
    if (q.result instanceof Promise) {
      q.result = await q.result;
    }
    const updatedDoc = q.result.findDoc(tx.objectId);
    if (updatedDoc !== void 0) {
      if (q.query.$search != null && q.query.$search.length > 0) {
        const searchRefresh = await this.checkSearch(q, tx.objectId);
        if (searchRefresh) return;
      } else {
        if (updatedDoc.modifiedOn < tx.modifiedOn) {
          await this.__updateDoc(q, updatedDoc, tx);
          const updateRefresh = this.checkUpdatedDocMatch(q, q.result, updatedDoc);
          if (updateRefresh) {
            return;
          }
        } else {
          const currentRefresh = await this.getCurrentDoc(q, updatedDoc._id, updatedDoc.space, docCache);
          if (currentRefresh) {
            return;
          }
        }
      }
      await this.sort(q, tx);
      const udoc = q.result.findDoc(tx.objectId);
      await this.updatedDocCallback(q, q.result, udoc);
    } else if (this.matchQuerySync(q, tx) && await this.matchQuery(q, tx, docCache)) {
      await this.sort(q, tx);
      const udoc = q.result.findDoc(tx.objectId);
      await this.updatedDocCallback(q, q.result, udoc);
    } else if (this.client.getHierarchy().isDerived(tx.objectClass, q._class) && q.options?.total === true && q.options.limit === q.result.length) {
      await this.refresh(q);
      return;
    }
    await this.handleDocUpdateLookup(q, tx);
    await this.handleDocUpdateRelation(q, tx);
  }
  isPossibleAssociationTx(tx, association) {
    const h = this.getHierarchy();
    const byClass = h.isDerived(tx.objectClass, association.classA) || h.isDerived(tx.objectClass, association.classB) || h.isDerived(association.classA, tx.objectClass) || h.isDerived(association.classB, tx.objectClass);
    if (byClass) {
      return true;
    }
    if (tx._class === import_core.default.class.TxMixin) {
      const mixinTx = tx;
      return h.isDerived(mixinTx.mixin, association.classA) || h.isDerived(mixinTx.mixin, association.classB);
    }
    return false;
  }
  async handleDocUpdateRelation(q, tx) {
    if (q.options?.associations === void 0) return;
    for (const assoc of q.options.associations) {
      const association = this.getModel().findObject(assoc[0]);
      if (association === void 0) continue;
      if (this.isPossibleAssociationTx(tx, association)) {
        if (q.result instanceof Promise) {
          q.result = await q.result;
        }
        const docs = q.result.getDocs();
        for (const doc of docs) {
          const docToUpdate = doc.$associations?.[`${association._id}_a`]?.find((it) => it._id === tx.objectId) ?? doc.$associations?.[`${association._id}_b`]?.find((it) => it._id === tx.objectId);
          if (docToUpdate !== void 0) {
            if (tx._class === import_core.default.class.TxMixin) {
              import_core.TxProcessor.updateMixin4Doc(docToUpdate, tx);
            } else {
              import_core.TxProcessor.updateDoc2Doc(docToUpdate, tx);
            }
            q.result.updateDoc(doc, false);
            this.queriesToUpdate.set(q.id, q);
          }
        }
      }
    }
  }
  async handleDocUpdateLookup(q, tx) {
    if (q.options?.lookup === void 0) return;
    const lookup = q.options.lookup;
    if (q.result instanceof Promise) {
      q.result = await q.result;
    }
    let needCallback = false;
    needCallback = await this.processLookupUpdateDoc(q.result, lookup, tx);
    if (needCallback) {
      if (q.options?.sort !== void 0) {
        q.result.sort(q._class, q.options.sort, this.getHierarchy(), this.client.getModel());
      }
      await this.callback(q, true);
    }
  }
  async processLookupUpdateDoc(docs, lookup, tx) {
    let needCallback = false;
    const lookupWays = this.getLookupWays(lookup, tx.objectClass);
    for (const lookupWay of lookupWays) {
      const [objWay, key, reverseLookupKey] = lookupWay;
      for (const resDoc of docs.getDocs()) {
        const obj = (0, import_core.getObjectValue)(objWay, resDoc);
        if (obj === void 0) continue;
        const value = (0, import_core.getObjectValue)("$lookup." + key, obj);
        if (Array.isArray(value)) {
          let index = value.findIndex((p) => p._id === tx.objectId);
          if (this.client.getHierarchy().isDerived(tx.objectClass, import_core.default.class.AttachedDoc)) {
            if (reverseLookupKey !== void 0) {
              const reverseLookupValue = (tx._class === import_core.default.class.TxMixin ? tx.attributes : tx.operations)[reverseLookupKey];
              if (index !== -1 && reverseLookupValue !== void 0 && reverseLookupValue !== obj._id) {
                value.splice(index, 1);
                index = -1;
                needCallback = true;
                docs.updateDoc(resDoc, false);
              } else if (index === -1 && reverseLookupValue === obj._id) {
                const doc = await this.findOne(tx.objectClass, { _id: tx.objectId });
                if (doc !== void 0) {
                  value.push(doc);
                  index = value.length - 1;
                }
                needCallback = true;
                docs.updateDoc(resDoc, false);
              }
            }
          }
          if (index !== -1) {
            if (tx._class === import_core.default.class.TxMixin) {
              import_core.TxProcessor.updateMixin4Doc(value[index], tx);
            } else {
              import_core.TxProcessor.updateDoc2Doc(value[index], tx);
            }
            needCallback = true;
            docs.updateDoc(resDoc, false);
          }
        } else {
          if (obj[key] === tx.objectId) {
            if (obj.$lookup[key] !== void 0) {
              if (tx._class === import_core.default.class.TxMixin) {
                import_core.TxProcessor.updateMixin4Doc(obj.$lookup[key], tx);
              } else {
                import_core.TxProcessor.updateDoc2Doc(obj.$lookup[key], tx);
              }
              needCallback = true;
              docs.updateDoc(resDoc, false);
            }
          }
        }
      }
    }
    return needCallback;
  }
  async refresh(q) {
    this.queriesToUpdate.delete(q.id);
    await q.refresh();
  }
  async doRefresh(q) {
    const qid = ++q.refreshId;
    const res = await this.client.findAll(q._class, q.query, q.options);
    if (q.refreshId === qid && (!(0, import_fast_equals.deepEqual)(res, q.result) || res.total !== q.total && q.options?.total === true)) {
      q.result = new import_results.ResultArray(res, this.getHierarchy());
      q.total = res.total;
      await this.callback(q);
    }
  }
  matchQuerySync(q, tx) {
    const clazz = this.getHierarchy().isMixin(q._class) ? this.getHierarchy().getBaseClass(q._class) : q._class;
    const target = tx.operations._class ?? tx.objectClass;
    if (!this.client.getHierarchy().isDerived(target, clazz)) {
      return false;
    }
    return true;
  }
  // Check if query is partially matched.
  async matchQuery(q, tx, docCache) {
    const doc = {
      _id: tx.objectId,
      _class: tx.objectClass,
      modifiedBy: tx.modifiedBy,
      modifiedOn: tx.modifiedOn,
      space: tx.objectSpace
    };
    const { $inc, ...ops } = tx.operations;
    const emptyOps = Object.keys(ops).length === 0;
    let matched = emptyOps || Object.keys(q.query).length === 0;
    if (!emptyOps) {
      const virtualTx = {
        ...tx,
        operations: ops
      };
      import_core.TxProcessor.updateDoc2Doc(doc, virtualTx);
      for (const key in q.query) {
        const value = q.query[key];
        const tkey = (0, import_core.checkMixinKey)(key, q._class, this.client.getHierarchy());
        if (doc[tkey] === void 0) continue;
        const res = (0, import_core.findProperty)([doc], tkey, value);
        if (res.length === 0) {
          return false;
        } else {
          matched = true;
        }
      }
    }
    if (matched) {
      const realDoc = await this.getDocFromCache(docCache, doc._id, import_core.Hierarchy.mixinOrClass(doc), doc.space, q);
      if (realDoc == null) return false;
      if (this.getHierarchy().isMixin(q._class)) {
        if (!this.getHierarchy().hasMixin(realDoc, q._class)) {
          return false;
        }
      }
      const res = (0, import_core.matchQuery)([realDoc], q.query, q._class, this.client.getHierarchy());
      if (res.length === 1) {
        if (q.result instanceof Promise) {
          q.result = await q.result;
        }
        const doc2 = res[0];
        const pos = q.result.findDoc(doc2._id);
        if (pos !== void 0) {
          q.result.updateDoc(doc2);
          this.refs.updateDocuments(q, [doc2]);
        } else {
          q.result.push(doc2);
          if (q.options?.total === true) {
            q.total++;
          }
        }
        return true;
      }
    }
    return false;
  }
  async getLookupValue(_class, doc, lookup, result) {
    for (const key in lookup) {
      if (key === "_id") {
        await this.getReverseLookupValue(doc, lookup, result);
        continue;
      }
      const value = lookup[key];
      const tkey = (0, import_core.checkMixinKey)(key, _class, this.client.getHierarchy());
      if (Array.isArray(value)) {
        const [_class2, nested] = value;
        result[key] = await this.findOne(_class2, { _id: (0, import_core.getObjectValue)(tkey, doc) });
        const nestedResult = {};
        const parent = result[key];
        if (parent !== void 0) {
          await this.getLookupValue(_class2, parent, nested, nestedResult);
          Object.assign(parent, {
            $lookup: nestedResult
          });
        }
      } else {
        ;
        result[key] = await this.findOne(value, { _id: (0, import_core.getObjectValue)(tkey, doc) });
      }
    }
  }
  async getReverseLookupValue(doc, lookup, result) {
    for (const key in lookup._id) {
      if (doc[key] === void 0 || doc[key] === 0) {
        continue;
      }
      const value = lookup._id[key];
      let _class;
      let attr = "attachedTo";
      if (Array.isArray(value)) {
        _class = value[0];
        attr = value[1];
      } else {
        _class = value;
      }
      ;
      result[key] = await this.findAll(_class, { [attr]: doc._id });
    }
  }
  async lookup(_class, doc, lookup) {
    const result = {};
    await this.getLookupValue(_class, doc, lookup, result);
    doc.$lookup = result;
  }
  async txCreateDoc(tx, docCache) {
    const docTx = import_core.TxProcessor.createDoc2Doc(tx);
    for (const queries of this.queries.entries()) {
      const doc = this.client.getHierarchy().isDerived(queries[0], import_core.default.class.Tx) ? tx : docTx;
      for (const q of queries[1].values()) {
        if (this.match(q, doc, q.options?.lookup !== void 0)) {
          await this.handleDocAdd(q, doc, true, docCache);
        }
        await this.handleDocAddLookup(q, doc);
        await this.handleDocAddRelation(q, doc);
      }
    }
    return {};
  }
  async handleDocAdd(q, doc, handleLookup = true, docCache) {
    let needPush = true;
    if (q.result instanceof Promise) {
      q.result = await q.result;
    }
    if (q.options?.lookup !== void 0 && handleLookup) {
      await this.lookup(q._class, doc, q.options.lookup);
      const matched = this.match(q, doc);
      if (!matched) needPush = false;
    }
    if (needPush) {
      const pos = q.result.findDoc(doc._id);
      if (pos !== void 0) {
        needPush = false;
      }
    }
    if (needPush) {
      if (q.query.$search != null && q.query.$search.length > 0) {
        const match = await this.client.findOne(q._class, { $search: q.query.$search, _id: doc._id }, q.options);
        if (match === void 0) return;
      }
      q.result.push(doc);
      if (q.options?.total === true) {
        q.total++;
      }
      if (q.options?.sort !== void 0) {
        q.result.sort(q._class, q.options.sort, this.getHierarchy(), this.client.getModel());
      }
      if (q.options?.limit !== void 0 && q.result.length > q.options.limit) {
        if (q.result.pop()?._id !== doc._id || q.options?.total === true) {
          await this.callback(q, true);
        }
      } else {
        await this.callback(q, true);
      }
    }
  }
  async callback(q, bulkUpdate = false) {
    if (q.result instanceof Promise) {
      q.result = await q.result;
    }
    const result = q.result;
    this.refs.updateDocuments(q, result.getDocs());
    if (bulkUpdate) {
      this.queriesToUpdate.set(q.id, q);
    } else {
      this.queriesToUpdate.delete(q.id);
      for (const [id, callback] of q.callbacks.entries()) {
        callback((0, import_core.toFindResult)(result.getResult(id), q.total));
      }
    }
  }
  async handleDocAddRelation(q, doc) {
    if (q.options?.associations === void 0) return;
    if (doc._class !== import_core.default.class.Relation) return;
    const relation = doc;
    const assoc = findAssociation(q.options.associations, relation.association);
    if (assoc !== void 0) {
      if (q.result instanceof Promise) {
        q.result = await q.result;
      }
      const res = await this.fillRelationDoc(q.result, q.result.getDocs(), q.options.associations, relation);
      if (res) {
        this.queriesToUpdate.set(q.id, q);
      }
    }
  }
  async fillRelationDoc(qRes, docs, associations, relation) {
    if (associations === void 0) return false;
    let result = false;
    for (const assoc of associations) {
      if (assoc[0] === relation.association) {
        const association = this.getModel().findObject(assoc[0]);
        if (association === void 0) continue;
        const sourceId = assoc[1] === 1 ? relation.docA : relation.docB;
        const targetId = assoc[1] === 1 ? relation.docB : relation.docA;
        const direct = assoc[1] === 1;
        for (const doc of docs) {
          if (doc._id === sourceId) {
            const nestedAssoc = assoc[2];
            const options = nestedAssoc !== void 0 ? {
              associations: nestedAssoc
            } : void 0;
            const docToPush = await this.findOne(
              direct ? association.classB : association.classA,
              {
                _id: targetId
              },
              options
            );
            if (docToPush === void 0) continue;
            if (doc.$associations === void 0) {
              doc.$associations = {};
            }
            const key = direct ? "b" : "a";
            const arr = doc.$associations?.[`${assoc[0]}_${key}`] ?? [];
            const exists = arr.findIndex((p) => p._id === docToPush._id);
            if (exists !== -1) {
              arr[exists] = docToPush;
            } else {
              arr.push(docToPush);
            }
            doc.$associations[`${assoc[0]}_${key}`] = arr;
            if (qRes.findDoc(doc._id) !== void 0) {
              qRes.updateDoc(doc, false);
            }
            result = true;
          }
        }
      }
    }
    for (const assoc of associations) {
      if (assoc[2] !== void 0) {
        const key = assoc[1] === 1 ? "b" : "a";
        for (const doc of docs) {
          const arr = doc.$associations?.[`${assoc[0]}_${key}`] ?? [];
          if (arr.length > 0) {
            const res = await this.fillRelationDoc(qRes, arr, assoc[2], relation);
            if (res) {
              result = true;
              if (qRes.findDoc(doc._id) !== void 0) {
                qRes.updateDoc(doc, false);
              }
            }
          }
        }
      }
    }
    return result;
  }
  async handleDocAddLookup(q, doc) {
    if (q.options?.lookup === void 0) return;
    const lookup = q.options.lookup;
    if (q.result instanceof Promise) {
      q.result = await q.result;
    }
    let needCallback = false;
    needCallback = this.proccesLookupAddDoc(q.result, lookup, doc);
    if (needCallback) {
      if (q.options?.sort !== void 0) {
        q.result.sort(q._class, q.options.sort, this.getHierarchy(), this.client.getModel());
      }
      await this.callback(q, true);
    }
  }
  proccesLookupAddDoc(docs, lookup, doc) {
    let needCallback = false;
    const lookupWays = this.getLookupWays(lookup, doc._class);
    for (const lookupWay of lookupWays) {
      const [objWay, key, reverseLookupKey] = lookupWay;
      for (const resDoc of docs.getDocs()) {
        const obj = (0, import_core.getObjectValue)(objWay, resDoc);
        if (obj === void 0) continue;
        let value = (0, import_core.getObjectValue)("$lookup." + key, obj);
        const reverseCheck = reverseLookupKey !== void 0 && doc[reverseLookupKey] === obj._id;
        if (value == null && reverseCheck) {
          value = [];
          obj.$lookup[key] = value;
          needCallback = true;
          docs.updateDoc(resDoc, false);
        }
        if (Array.isArray(value)) {
          if (this.client.getHierarchy().isDerived(doc._class, import_core.default.class.AttachedDoc) && reverseCheck) {
            const idx = value.findIndex((p) => p._id === doc._id);
            if (idx === -1) {
              value.push(doc);
            } else {
              value[idx] = doc;
            }
            needCallback = true;
            docs.updateDoc(resDoc, false);
          }
        } else {
          if (obj[key] === doc._id) {
            obj.$lookup[key] = doc;
            needCallback = true;
            docs.updateDoc(resDoc, false);
          }
        }
      }
    }
    return needCallback;
  }
  async txRemoveDoc(tx, docCache) {
    for (const queries of this.queries.entries()) {
      const isTx = this.client.getHierarchy().isDerived(queries[0], import_core.default.class.Tx);
      for (const q of queries[1].values()) {
        if (isTx) {
          if (this.match(q, tx, q.options?.lookup !== void 0)) {
            await this.handleDocAdd(q, tx, true, docCache);
          }
          await this.handleDocAddLookup(q, tx);
          continue;
        }
        await this.handleDocRemove(q, tx);
      }
    }
    return {};
  }
  async handleDocRemove(q, tx) {
    const h = this.client.getHierarchy();
    if (q._class === tx.objectClass || h.isDerived(q._class, tx.objectClass) || h.isDerived(tx.objectClass, q._class)) {
      if (q.result instanceof Promise) {
        q.result = await q.result;
      }
      const index = q.result.getDocs().find((p) => p._id === tx.objectId);
      if (index !== void 0) {
        if (q.options?.limit !== void 0 && q.options.limit === q.result.length && q.query._id !== tx.objectId) {
          await this.refresh(q);
          return;
        }
        q.result.delete(index._id);
        this.refs.updateDocuments(q, [index], true);
        if (q.options?.total === true) {
          q.total--;
        }
        await this.callback(q, true);
      }
    }
    await this.handleDocRemoveLookup(q, tx);
    await this.handleDocRemoveRelation(q, tx);
  }
  async handleDocRemoveRelation(q, tx) {
    if (q.options?.associations === void 0) return;
    if (tx.objectClass !== import_core.default.class.Relation) return;
    await this.refresh(q);
  }
  async handleDocRemoveLookup(q, tx) {
    if (q.options?.lookup === void 0) return;
    let needCallback = false;
    const lookupWays = this.getLookupWays(q.options.lookup, tx.objectClass);
    if (lookupWays.length === 0) return;
    if (q.result instanceof Promise) {
      q.result = await q.result;
    }
    for (const lookupWay of lookupWays) {
      const [objWay, key] = lookupWay;
      const docs = q.result;
      for (const doc of docs.getDocs()) {
        const obj = (0, import_core.getObjectValue)(objWay, doc);
        if (obj === void 0) continue;
        const value = (0, import_core.getObjectValue)("$lookup." + key, obj);
        if (value === void 0) continue;
        if (Array.isArray(value)) {
          const index = value.findIndex((p) => p._id === tx.objectId);
          if (index !== -1) {
            value.splice(index, 1);
            needCallback = true;
            docs.updateDoc(doc, false);
          }
        } else {
          if (value._id === tx.objectId) {
            obj.$lookup[key] = void 0;
            needCallback = true;
            docs.updateDoc(doc, false);
          }
        }
      }
    }
    if (needCallback) {
      if (q.options?.sort !== void 0) {
        q.result.sort(q._class, q.options.sort, this.getHierarchy(), this.client.getModel());
      }
      await this.callback(q, true);
    }
  }
  getLookupWays(lookup, _class, parent = "") {
    const result = [];
    const hierarchy = this.client.getHierarchy();
    if (lookup._id !== void 0) {
      for (const key in lookup._id) {
        const value = lookup._id[key];
        const [valueClass, reverseLookupKey] = Array.isArray(value) ? value : [value, "attachedTo"];
        const clazz = hierarchy.isMixin(valueClass) ? hierarchy.getBaseClass(valueClass) : valueClass;
        if (hierarchy.isDerived(_class, clazz)) {
          result.push([parent, key, reverseLookupKey]);
        }
      }
    }
    for (const key in lookup) {
      if (key === "_id") continue;
      const value = lookup[key];
      if (Array.isArray(value)) {
        const clazz = hierarchy.isMixin(value[0]) ? hierarchy.getBaseClass(value[0]) : value[0];
        if (hierarchy.isDerived(_class, clazz)) {
          result.push([parent, key]);
        }
        const lookupKey = "$lookup." + key;
        const newParent = parent.length > 0 ? parent + "." + lookupKey : lookupKey;
        const nested = this.getLookupWays(value[1], _class, newParent);
        if (nested.length > 0) {
          result.push(...nested);
        }
      } else {
        const clazz = hierarchy.isMixin(value) ? hierarchy.getBaseClass(value) : value;
        if (hierarchy.isDerived(_class, clazz)) {
          result.push([parent, key]);
        }
      }
    }
    return result;
  }
  async _tx(tx, docCache) {
    switch (tx._class) {
      case import_core.default.class.TxCreateDoc:
        return await this.txCreateDoc(tx, docCache);
      case import_core.default.class.TxUpdateDoc:
        return await this.txUpdateDoc(tx, docCache);
      case import_core.default.class.TxRemoveDoc:
        return await this.txRemoveDoc(tx, docCache);
      case import_core.default.class.TxMixin:
        return await this.txMixin(tx, docCache);
      case import_core.default.class.TxApplyIf:
        return await Promise.resolve([]);
    }
    return {};
  }
  async tx(...txes) {
    const result = [];
    const docCache = /* @__PURE__ */ new Map();
    for (const tx of txes) {
      if (tx._class === import_core.default.class.TxWorkspaceEvent) {
        const evt = tx;
        await this.checkUpdateEvents(evt);
        await this.changePrivateHandler(evt);
      }
      result.push(await this._tx(tx, docCache));
    }
    if (this.queriesToUpdate.size > 0) {
      const copy = new Map(this.queriesToUpdate);
      this.queriesToUpdate.clear();
      for (const q of copy.values()) {
        if (q.result instanceof Promise) {
          q.result = await q.result;
        }
        const qr = q.result;
        for (const [id, callback] of q.callbacks.entries()) {
          callback((0, import_core.toFindResult)(qr.getResult(id), q.total));
        }
      }
    }
    return result;
  }
  async checkUpdateEvents(evt, trigger = true) {
    const h = this.client.getHierarchy();
    function hasClass(q, classes) {
      return classes.includes(q._class) || classes.some((it) => h.isDerived(q._class, it) || h.isDerived(it, q._class));
    }
    __name(hasClass, "hasClass");
    if (evt.event === import_core.WorkspaceEvent.IndexingUpdate) {
      const indexingParam = evt.params;
      for (const q of [...this.queue.values()]) {
        if (hasClass(q, indexingParam._class) && q.query.$search !== void 0) {
          if (!this.removeFromQueue(q)) {
            try {
              await this.refresh(q);
            } catch (err) {
              import_analytics.Analytics.handleError(err);
              console.error(err);
            }
          } else {
            this.removeQueue(q);
          }
        }
      }
      for (const v of this.queries.values()) {
        for (const q of v.values()) {
          if (hasClass(q, indexingParam._class) && q.query.$search !== void 0) {
            try {
              await this.refresh(q);
            } catch (err) {
              import_analytics.Analytics.handleError(err);
              console.error(err);
            }
          }
        }
      }
    }
    if (evt.event === import_core.WorkspaceEvent.BulkUpdate) {
      const params = evt.params;
      for (const q of [...this.queue.values()]) {
        if (hasClass(q, params._class)) {
          if (!this.removeFromQueue(q)) {
            try {
              await this.refresh(q);
            } catch (err) {
              import_analytics.Analytics.handleError(err);
              console.error(err);
            }
          }
        }
      }
      for (const v of this.queries.values()) {
        for (const q of v.values()) {
          if (hasClass(q, params._class)) {
            try {
              await this.refresh(q);
            } catch (err) {
              import_analytics.Analytics.handleError(err);
              console.error(err);
            }
          }
        }
      }
    }
  }
  async changePrivateHandler(evt) {
    if (evt.event === import_core.WorkspaceEvent.SecurityChange) {
      for (const q of [...this.queue.values()]) {
        if (typeof q.query.space !== "string" || q.query.space === evt.objectSpace) {
          if (!this.removeFromQueue(q)) {
            try {
              await this.refresh(q);
            } catch (err) {
              import_analytics.Analytics.handleError(err);
              console.error(err);
            }
          }
        }
      }
      for (const v of this.queries.values()) {
        for (const q of v.values()) {
          if (typeof q.query.space !== "string" || q.query.space === evt.objectSpace) {
            try {
              await this.refresh(q);
            } catch (err) {
              import_analytics.Analytics.handleError(err);
              console.error(err);
            }
          }
        }
      }
    }
  }
  async __updateLookup(q, updatedDoc, ops) {
    for (const key in ops) {
      if (!key.startsWith("$")) {
        if (q.options !== void 0) {
          const lookup = q.options.lookup?.[key];
          if (lookup !== void 0) {
            const lookupClass = getLookupClass(lookup);
            const nestedLookup = getNestedLookup(lookup);
            if (Array.isArray(ops[key])) {
              ;
              updatedDoc.$lookup[key] = await this.findAll(
                lookupClass,
                { _id: { $in: ops[key] } },
                { lookup: nestedLookup }
              );
            } else {
              ;
              updatedDoc.$lookup[key] = await this.findOne(
                lookupClass,
                { _id: ops[key] },
                { lookup: nestedLookup }
              );
            }
          }
        }
      } else {
        if (key === "$push") {
          const pops = ops[key] ?? {};
          for (const pkey of Object.keys(pops)) {
            if (q.options !== void 0) {
              const lookup = q.options.lookup?.[pkey];
              if (lookup !== void 0) {
                const lookupClass = getLookupClass(lookup);
                const nestedLookup = getNestedLookup(lookup);
                const pp = updatedDoc.$lookup;
                if (pp[pkey] === void 0) {
                  pp[pkey] = [];
                }
                if (Array.isArray(pops[pkey])) {
                  const pushData = await this.findAll(
                    lookupClass,
                    { _id: { $in: pops[pkey] } },
                    { lookup: nestedLookup }
                  );
                  pp[pkey].push(...pushData);
                } else {
                  const d = await this.findOne(lookupClass, { _id: pops[pkey] }, { lookup: nestedLookup });
                  if (d !== void 0) {
                    pp[pkey].push(d);
                  }
                }
              }
            }
          }
        } else if (key === "$pull") {
          const pops = ops[key] ?? {};
          for (const pkey of Object.keys(pops)) {
            if (q.options !== void 0) {
              const lookup = q.options.lookup?.[pkey];
              if (lookup !== void 0) {
                const pid = pops[pkey];
                const pp = updatedDoc.$lookup;
                if (pp[pkey] === void 0) {
                  pp[pkey] = [];
                }
                if (Array.isArray(pid)) {
                  pp[pkey] = pp[pkey].filter((it) => !pid.includes(it._id));
                } else {
                  pp[pkey] = pp[pkey].filter((it) => it._id !== pid);
                }
              }
            }
          }
        }
      }
    }
  }
  async __updateDoc(q, updatedDoc, tx) {
    import_core.TxProcessor.updateDoc2Doc(updatedDoc, tx);
    const ops = {
      ...tx.operations,
      modifiedBy: tx.modifiedBy,
      modifiedOn: tx.modifiedOn
    };
    await this.__updateLookup(q, updatedDoc, ops);
  }
  async sort(q, tx) {
    const sort = q.options?.sort;
    if (sort === void 0) return;
    let needSort = sort.modifiedBy !== void 0 || sort.modifiedOn !== void 0;
    if (!needSort) needSort = this.checkNeedSort(sort, tx);
    if (needSort) {
      if (q.result instanceof Promise) {
        q.result = await q.result;
      }
      q.result.sort(q._class, sort, this.getHierarchy(), this.client.getModel());
    }
  }
  checkNeedSort(sort, tx) {
    const ops = tx._class === import_core.default.class.TxMixin ? tx.attributes : tx.operations;
    for (const key in ops) {
      if (key.startsWith("$")) {
        for (const opKey in ops[key]) {
          if (opKey in sort) return true;
        }
      } else {
        if (key in sort) return true;
      }
    }
    return false;
  }
  async updatedDocCallback(q, res, updatedDoc) {
    if (q.options?.limit !== void 0 && res.length > q.options.limit) {
      if (updatedDoc === void 0) {
        await this.refresh(q);
        return;
      }
      if (res.getDocs()[q.options?.limit]._id === updatedDoc._id) {
        await this.refresh(q);
        return;
      }
      if (res.pop()?._id !== updatedDoc._id) {
        await this.callback(q, true);
      }
    } else {
      await this.callback(q, true);
    }
  }
}
function getNestedLookup(lookup) {
  return Array.isArray(lookup) ? lookup[1] : void 0;
}
__name(getNestedLookup, "getNestedLookup");
function getLookupClass(lookup) {
  return Array.isArray(lookup) ? lookup[0] : lookup;
}
__name(getLookupClass, "getLookupClass");
function findAssociation(associations, association) {
  for (const assoc of associations) {
    if (assoc[0] === association) return assoc;
  }
  for (const assoc of associations) {
    if (assoc[2] !== void 0) {
      const res = findAssociation(assoc[2], association);
      if (res !== void 0) {
        return assoc;
      }
    }
  }
}
__name(findAssociation, "findAssociation");
//# sourceMappingURL=index.js.map
